import { create } from 'zustand';
import axiosInstance from '../api/axios';

const useNotepadStore = create((set, get) => ({
  notepadItems: [], // Array of {product_id, quantity}
  loading: false,

  // Fetch notepad from backend
  fetchNotepad: async () => {
    try {
      set({ loading: true });
      const response = await axiosInstance.get('/notepad');
      set({ notepadItems: response.data.items || [], loading: false });
    } catch (error) {
      console.error('Error fetching notepad:', error);
      set({ loading: false });
    }
  },

  // Add or update product in notepad with quantity
  addToNotepad: async (productId, quantity = 1) => {
    try {
      await axiosInstance.post(`/notepad/${productId}?quantity=${quantity}`);
      
      // Update local state
      set((state) => {
        const existingIndex = state.notepadItems.findIndex(item => item.product_id === productId);
        
        if (existingIndex >= 0) {
          // Update quantity
          const newItems = [...state.notepadItems];
          newItems[existingIndex] = { product_id: productId, quantity };
          return { notepadItems: newItems };
        } else {
          // Add new item
          return {
            notepadItems: [...state.notepadItems, { product_id: productId, quantity }]
          };
        }
      });
      
      return true;
    } catch (error) {
      console.error('Error adding to notepad:', error);
      return false;
    }
  },

  // Remove product from notepad
  removeFromNotepad: async (productId) => {
    try {
      await axiosInstance.delete(`/notepad/${productId}`);
      set((state) => ({
        notepadItems: state.notepadItems.filter(item => item.product_id !== productId)
      }));
      return true;
    } catch (error) {
      console.error('Error removing from notepad:', error);
      return false;
    }
  },

  // Check if product is in notepad
  isInNotepad: (productId) => {
    return get().notepadItems.some(item => item.product_id === productId);
  },

  // Get quantity for a product
  getQuantity: (productId) => {
    const item = get().notepadItems.find(item => item.product_id === productId);
    return item ? item.quantity : 1;
  },

  // Get notepad count
  getNotepadCount: () => {
    return get().notepadItems.length;
  },

  // Clear notepad (on logout)
  clearNotepad: () => {
    set({ notepadItems: [], loading: false });
  }
}));

export default useNotepadStore;
